import { ASIDE_PANEL_COLUMN_RELEASE, EFeature } from 'app/types/rest/IUserMeta';
import { IApplicationState } from '../../../../../types/types';
import { getAuthUser } from '../getAuthUser';
import { isNewFeatureForUser } from '../isNewFeatureForUser';

export const getIsNewFeatureAsidePanelColumnTipsSeen = (
    state: IApplicationState
): boolean => {
    let isNewFeature = isNewFeatureForUser(state, EFeature.ASIDE_PANEL_COLUMN_TIPS_SEEN);
    if (!isNewFeature) return false;

    const user = getAuthUser(state);
    if (user && user.createDateTimeStamp && user.createDateTimeStamp > ASIDE_PANEL_COLUMN_RELEASE) return false;

    return true;
};
